module.exports = __webpack_public_path__ + "img/uk-retail-2.41edede2.png";